import React, { useState } from 'react';
import MarketingColumn from '../components/marketingColumn';
import SubNav from "../components/subNav";
import SEO from '../components/SEO';
import { baseUrl } from '../config';



function CampaignTracker() {
  const [campaigns, setCampaigns] = useState([
    { title: 'Campaign 1', description: 'Plan social media posts.', dueDate: '2024-09-15', progress: 40, assignedTo: 'Alice', column: 'Planning' },
    { title: 'Campaign 2', description: 'Create ad creatives.', dueDate: '2024-09-20', progress: 60, assignedTo: 'Bob', column: 'Content Creation' },
    { title: 'Campaign 3', description: 'Set up Google Ads.', dueDate: '2024-09-25', progress: 30, assignedTo: 'Charlie', column: 'Ad Setup' },
    { title: 'Campaign 4', description: 'Monitor live performance.', dueDate: '2024-09-30', progress: 70, assignedTo: 'David', column: 'Live Campaign' }
  ]);

  const addCampaign = (campaign) => {
    setCampaigns([...campaigns, campaign]);
  };

  const updateCampaign = (index, updatedCampaign) => {
    const updatedCampaigns = [...campaigns];
    updatedCampaigns[index] = updatedCampaign;
    setCampaigns(updatedCampaigns);
  };

  const dropCampaign = (campaignIndex, fromColumn, toColumn) => {
    const campaignToMove = campaigns[campaignIndex];
    const updatedCampaign = { ...campaignToMove, column: toColumn };

    const filteredCampaigns = campaigns.filter((_, index) => index !== campaignIndex);
    setCampaigns([...filteredCampaigns, updatedCampaign]);
  };

  return (
    <>
    <SEO
      title="Marketing Tracker"
      description="Track your film's marketing campaign performance, budgets, and results with ProducerBuddy's marketing tracker."
      url="https://producerbuddy.pilomation.com/marketing-tracker"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='flex flex-col p-3 justify-center items-center'>
      <h2 style={{fontSize:'24px'}} className='font-bold'>Progress Tracker</h2>
      <p className='mt-3 font-semibold'>"Keeping tasks on track, one step at a time."</p>
    </div>
    <div className="flex p-4 justify-around h-screen">
      <MarketingColumn
        column="Planning"
        campaigns={campaigns.filter((campaign) => campaign.column === 'Planning')}
        onAddCampaign={addCampaign}
        onUpdateCampaign={updateCampaign}
        onDropCampaign={dropCampaign}
      />
      <MarketingColumn
        column="Content Creation"
        campaigns={campaigns.filter((campaign) => campaign.column === 'Content Creation')}
        onAddCampaign={addCampaign}
        onUpdateCampaign={updateCampaign}
        onDropCampaign={dropCampaign}
      />
      <MarketingColumn
        column="Ad Setup"
        campaigns={campaigns.filter((campaign) => campaign.column === 'Ad Setup')}
        onAddCampaign={addCampaign}
        onUpdateCampaign={updateCampaign}
        onDropCampaign={dropCampaign}
      />
      <MarketingColumn
        column="Live Campaign"
        campaigns={campaigns.filter((campaign) => campaign.column === 'Live Campaign')}
        onAddCampaign={addCampaign}
        onUpdateCampaign={updateCampaign}
        onDropCampaign={dropCampaign}
      />
      <MarketingColumn
        column="Completed"
        campaigns={campaigns.filter((campaign) => campaign.column === 'Completed')}
        onAddCampaign={addCampaign}
        onUpdateCampaign={updateCampaign}
        onDropCampaign={dropCampaign}
      />
    </div>
    </>
    
  );
}

export default CampaignTracker;

